import { useTranslation } from "react-i18next";
import { Paper } from "@material-ui/core";
import StorageAccount from "./StorageAccount";
import AdvancedOptions from "./AdvancedOptions";
import { StepHeader } from "./Styled";
import { isOrganization } from "./utils";
import useSecurityItems from "../../../hooks/useSecurityItems";
import { useRuleContext } from "../../context/ruleContext";
import { getCloudStorage } from "pages/Rules/Form/context/ruleSelectors";
import {
  translationKey as providerTKey,
  selectProvider,
} from "components/StorageProviderLabel";

export default function CloudStorage() {
  const { t } = useTranslation("rules");
  const { state } = useRuleContext();
  const storage = getCloudStorage(state.rule);
  const expanded = state.steps?.cloudStorage?.expanded;
  const { securityOptions } = useSecurityItems();
  const isZipAttachmentsRule = state.type === "ZIP_ATTACHMENTS";

  const getSubtitle = () => {
    if (!storage) return null;
    const { provider } = storage;
    if (provider) {
      return isOrganization(storage?.authentication)
        ? t(`cloudStorage.accounts.org.${provider}`)
        : t(providerTKey(provider));
    }
    return t(selectProvider);
  };

  return (
    <Paper>
      <StepHeader
        title={`3. ${t("cloudStorage.header.title")}`}
        subtitle={getSubtitle()}
        selected={Boolean(storage && storage.provider)}
      />

      {expanded && (
        <>
          <StorageAccount securityOptions={securityOptions} />
          {!isZipAttachmentsRule && (
            <AdvancedOptions securityOptions={securityOptions} />
          )}
        </>
      )}
    </Paper>
  );
}
